// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__i3Zkn","buttons":"SendReceipts_buttons__14IFy","email":"SendReceipts_email__2nL_N","bookApptTitle":"SendReceipts_bookApptTitle__AwIer"};